export default function(d) {
  return d;
}



//////////////////
// WEBPACK FOOTER
// C:/Users/user/projects/ansyn/node_modules/d3-shape/src/identity.js
// module id = ../../../../d3-shape/src/identity.js
// module chunks = vendor